import React from "react";
import style from "./PromoInformationCard.module.css";
import Paragraph, { ParagraphSize } from "../../../components/Paragraph";

interface PromoInformationCardProps {
  title?: string;
  description?: string;
}

const PromoInformationCard: React.FC<PromoInformationCardProps> = ({
  title,
  description,
}) => {
  const informContainer = (
    <div className={style["info-container"]}>
      <Paragraph
        size={ParagraphSize.paragraph2}
        classNameStyle={style["title-highlight"]}
      >
        {title}
      </Paragraph>
      <Paragraph size={ParagraphSize.paragraph2}>{description}</Paragraph>
    </div>
  );

  return <div className={style["parent-container"]}>{informContainer}</div>;
};

export default PromoInformationCard;
